import {ApiResponse} from "@/entities/api-response";
import {ITranslationsService} from "@/services/itranslations.service";
import {TranslationsApiService} from "@/services/translations-api.service";
import {LocaleMessageObject} from 'vue-i18n'
import axios from 'axios'
import {API_URL} from '@/config/api-config'

export class TranslationsService implements ITranslationsService {
  private service: TranslationsApiService;

  constructor(translationsApiService?: TranslationsApiService) {
    this.service = translationsApiService || new TranslationsApiService()
  }

  postCulture(locale: string): Promise<ApiResponse> {
    return this.service.postCulture(locale).then((res: ApiResponse) => res.content)
  }
}

export async function getAllTranslations() : Promise<LocaleMessageObject> {
  try {
    const res = await axios.get(`${API_URL}/translations`)
    if (res.data?.content && typeof(res.data.content) === 'object') {
      return patchTranslationContent(res.data.content)
    }
  } catch (exception) {
    console.warn('getAllTranslations failed with an exception', exception)
  }

  return {} as LocaleMessageObject
}

export async function getTranslations(locale: string) : Promise<LocaleMessageObject> {
  if (!locale || locale.length !== 2) {
    locale = 'en'
  }

  try {
    const res = await axios.get(`${API_URL}/translations/${locale}`)
    if (res.data?.content && typeof res.data.content === 'object') {
      return patchTranslationContent(res.data.content)
    }
  } catch (error) {
    console.warn('translation returned wrong content', error)
  }

  return {} as LocaleMessageObject
}

// ===== RAW placeholder store =====
const rawStore = new Map<string, string>()
let rawCounter = 0

function makeRawPlaceholder(original: string): string {
  const key = `__RAW_TOKEN_${rawCounter++}__`
  rawStore.set(key, original)
  // wrap in single quotes to make ICU parser happy
  return `'${key}'`
}

function escapeICU(str: string): string {
  // Escape single quotes
  return str.replace(/'/g, "''")
}

// Patch translation content recursively
export function patchTranslationContent(obj: any): any {
  if (typeof obj === 'string') {
    let patched = obj

    // wrap HTML, emails, URLs
    // patched = patched.replace(/<[^>]+>/g, m => makeRawPlaceholder(m));
    patched = patched.replace(/\bmailto:[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/gi, m => makeRawPlaceholder(m));
    patched = patched.replace(/(?<!mailto:)\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/gi, m => makeRawPlaceholder(m));
    patched = patched.replace(/\bhttps?:\/\/[^\s<>"']+/gi, m => makeRawPlaceholder(m));
    patched = patched.replace(/\b[A-Za-z0-9]+[®™]\b/g, m => makeRawPlaceholder(m));
    patched = patched.replace(/\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/gi, m => makeRawPlaceholder(m));

    // Escape ICU special characters for values
    // patched = escapeICU(patched);

    return patched;
  } else if (typeof obj === 'object' && obj !== null) {
    const newObj: any = Array.isArray(obj) ? [] : {}
    for (const key in obj) {
      newObj[key] = patchTranslationContent(obj[key])
    }
    return newObj
  }

  return obj
}

// Restore raw placeholders
export function unpatchTranslationContent(str: string): string {
  let result = str;
  for (const [key, original] of rawStore.entries()) {
    // Ищем все возможные обёртки после escapeICU
    const patterns = [
      `'${key}'`,      // одна кавычка (исходный плейсхолдер)
      `''${key}''`,    // две кавычки (после escapeICU)
      key              // без кавычек (запасной)
    ];
    for (const pattern of patterns) {
      result = result.replaceAll(pattern, original);
    }
  }
  return result;
}
